import React, { Component } from "react";
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";
import Dispositioning from "@arachnys/dispositioning";

import { withProps } from "./util";

import PrivateRoute from "./container/PrivateRoute";
import RedirectWithSearch from "./container/RedirectWithSearch";
import TopBar from "./container/TopBar";
import { PERMISSION_DENIED_PATH } from "./config";

// Pages
import LoginPage from "./page/Login";
import { Logout, CrossTabLogoutHandler } from "./page/Logout";
import HumanTaskPage from "./page/HumanTask";
import ClaimHumanTaskPage from "./page/HumanTask/ClaimHumanTask";
import EntityDetailPage from "./page/EntityDetail";
import InsightPage from "./page/Insight";
import TestErrorPage from "./page/TestError";
import EntityStorePage from "./page/EntityStore";
import LayoutComponent from "./App/Layout";
import ProcessHistoryPage from "./page/ProcessHistory";
import FlowPermissionDeniedPage from "./page/FlowPermissionDenied";
import UploadsHistoryPage from "./page/UploadsHistory";

// Legacy
import { Tasks } from "./page/Tasks/Tasks";

const menuItems = [
    {
        atId: "insight-link",
        link: "/insight/",
        label: "Insight",
        icon: "area-chart",
    },
    {
        atId: "research-items-link",
        link: "/tasks/",
        label: "Research Items",
        icon: "exception",
    },
    {
        atId: "entity-store-link",
        link: "/entities/",
        label: "Entity Store",
        icon: "solution",
    },
];

class App extends Component {
    state = {
        layoutType: "blank",
    };

    changeLayoutType = type => {
        if (this.state.layoutType !== type) {
            this.setState({ layoutType: type });
        }
    };

    render() {
        const PrivateRouteFn = withProps(PrivateRoute, {
            changeLayoutType: this.changeLayoutType,
            oldLayoutType: this.state.layoutType,
        });
        return (
            <BrowserRouter basename="/beta/">
                <>
                    <Switch>
                        <Route path="/logout" render={() => null} />
                        {/* render logout handler everywhere except /logout, this is easier than long regex */}
                        <Route path="/" component={CrossTabLogoutHandler} />
                    </Switch>
                    <LayoutComponent
                        layoutType={this.state.layoutType}
                        menuItems={menuItems}
                        TopBarComponent={TopBar}
                    >
                        <Switch>
                            <PrivateRouteFn
                                exact
                                layoutType="menu"
                                path="/insight/"
                                component={InsightPage}
                            />
                            <PrivateRouteFn
                                component={Dispositioning}
                                exact
                                layoutType="menu"
                                path="/dispositioning/:blockId"
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/entities/"
                                component={EntityStorePage}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path={[
                                    "/entities/:ulid/",
                                    "/entities/:ulid/:tab/",
                                ]}
                                component={EntityDetailPage}
                                styleless
                            />
                            <PrivateRouteFn
                                exact
                                path="/tasks/"
                                layoutType="bar"
                                styleless
                                render={() => (
                                    <Tasks
                                        nameRenderer={task => {
                                            if (!task) {
                                                return null;
                                            }

                                            if (!task.assignable) {
                                                return task.title;
                                            }

                                            return (
                                                <Link
                                                    to={`/tasks/${task.uid}/claim/`}
                                                >
                                                    {task.title}
                                                </Link>
                                            );
                                        }}
                                    />
                                )}
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="menu"
                                path="/tasks/:id/"
                                component={HumanTaskPage}
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/uploads-history/"
                                component={UploadsHistoryPage}
                            />
                            <PrivateRoute
                                exact
                                layoutType="menu"
                                path="/tasks/:id/claim/"
                                component={ClaimHumanTaskPage}
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="menu"
                                path="/logout/"
                                component={Logout}
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="bar"
                                path="/entities/:entityUlid/process-history/:id/"
                                component={ProcessHistoryPage}
                            />
                            <PrivateRouteFn
                                exact
                                layoutType="menu"
                                path={PERMISSION_DENIED_PATH}
                                component={FlowPermissionDeniedPage}
                            />
                            <Route path="/login/" component={LoginPage} />
                            <Route
                                path="/_test_error/"
                                component={TestErrorPage}
                            />

                            <RedirectWithSearch from="/" to="/entities/" />
                        </Switch>
                    </LayoutComponent>
                </>
            </BrowserRouter>
        );
    }
}

export default App;
